import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useLang } from '../../util/lang';

const NewErrorMessageDialog = (props) => {
    const get = useLang();
    const { title, children, open, setOpen, onOk } = props;

    return (
        <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="ok-dialog">
            <DialogTitle id="ok-dialog">{title}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => {
                        setOpen(false);
                        if (onOk) onOk();
                    }}
                    style={{ backgroundColor: props.backgroundColor || '#0080FF', color: props.color || 'white' }}
                >
                    {get(':const.ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default NewErrorMessageDialog;
